import React, {useEffect} from 'react';
import {Accordion, AccordionDetails, AccordionSummary, makeStyles, useMediaQuery} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {getCatalog, getPunkts, selectActivePatientResults, setCabinetActiveTab} from "@cabinet-packages/redux";
import CabinetPatientAssaysHistory from "./CabinetPatientAssaysHistory";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CabinetOrdersHistory from "./CabinetOrdersHistory";

const useStyles = makeStyles((theme) => ({
    scrollContainer: {
        padding: '0 10px',
        width: '100%',
        height: 'calc(100vh - 50px)', // Set a fixed height
        overflowY: 'scroll', // Enable scrolling

        '@media(min-width: 900px)': {
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    },
    rootWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        rowGap: '8px',
        padding: '10px',
        width: '100%',
        margin: '0 auto',
        height: "max-content",

        '@media (max-width:1200px)': {
            justifyItems: 'center',
            gridTemplateColumns: '1fr 1fr',
            width: '100%',
        },
        '@media (max-width:600px)': {
            gridTemplateColumns: '1fr',
        },
    },
    headerLabel: {
        color: theme.palette.primary.dark,
    },
    extraLabel: {
        color: theme.palette.primary.main,
    },
}))

const CabinetOrderHistoryWrapper = () => {
    const cl = useStyles()
    const { listOfPatients} = useSelector(state => state.patients)
    const {catalog, takeId, complexId} = useSelector(state => state.assaysCatalog)
    const dispatch = useDispatch()
    const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));


    useEffect(() => {
        if (!catalog && takeId && complexId) {
            dispatch(getCatalog())
        }
    }, [catalog, takeId, complexId]);

    useEffect(() => {
        dispatch(getPunkts());
    }, []);

    return <div className={cl.scrollContainer}>
        <div>
            <Typography
                color={"textPrimary"}
                variant={mdUp ? "h4" : "h5"}
                className={cl.headerLabel}
            >
                Замовленні дослідження
            </Typography>
            <Typography className={cl.extraLabel}>
                Перелік обраних Вами аналізів
            </Typography>
        </div>
        <div className={cl.assaysWrapper}>
            {listOfPatients && listOfPatients?.map(patient => (
                <Accordion key={patient.id}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        {patient && <Typography className={cl.extraLabel}>
                            Пацієнт: {`${patient.firstname} ${patient.lastname} ${patient.fathername}`}
                        </Typography>}
                    </AccordionSummary>
                    <AccordionDetails>
                        <CabinetOrdersHistory activePatient={patient}/>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    </div>
}

export default CabinetOrderHistoryWrapper;
